import type { FcwShowcaseHelpTemplateProps } from '@/components/templates/FcwShowcaseHelpTemplate.vue';

export function mapCmsShowcaseDataToShowcaseHelpProps(
  showcaseHelpRawData: StrapiResponseData<ShowcaseHelpContentType> | undefined
): FcwShowcaseHelpTemplateProps {
  const cmsData = showcaseHelpRawData?.attributes;

  return {
    sharingFaqItemIds: (cmsData?.faqs?.sharing_faq_items ?? [])
      .filter(article => article.article_id)
      .map(article => article.article_id ?? ''),
    leasingFaqItemIds: (cmsData?.faqs?.leasing_faq_items ?? [])
      .filter(article => article.article_id)
      .map(article => article.article_id ?? ''),
  };
}
